export enum U2CertificateLevelEnum {
  LIGHT_CERTIFICATE_POLICY = "lcp",
  QUALIFIED_CERTIFICATE_POLICY = "qcp",
}
